<template>
  <BaseCheckbox v-model="checked" :validate="{}" class="filter-checkbox">
    <span class="filter-checkbox__title">
      <slot />
    </span>
  </BaseCheckbox>
</template>

<script setup>
import BaseCheckbox from "~/modules/shared/inputs/BaseCheckbox.vue";
import { useProductFilterStore } from "~/store/productFilter.store.js";

const props = defineProps({
  specificationSlug: { type: String, required: true },
  optionSlug: { type: String, required: true },
});

const { hasSpecification, toggleSpecification } = useProductFilterStore();

const checked = computed({
  get() {
    return hasSpecification(props.specificationSlug, props.optionSlug);
  },
  set() {
    toggleSpecification(props.specificationSlug, props.optionSlug);
  },
});
</script>

<style lang="scss" scoped></style>
